import React, { createContext, useState } from 'react';

export interface ROPatientContextType {
  patientDetails: any;
  setPatientDetails: (details: any) => void;
  patientAlerts: any;
  setPatientAlerts: (alerts: any) => void;
  moreDetails: any;
  setMoreDetails: (details: any) => void;
  moreDetailsLoading: boolean;
  setMoreDetailsLoading: (loading: boolean) => void;
}

export const ROPatientContext = createContext<ROPatientContextType>({
  patientDetails: undefined,
  setPatientDetails: () => {},
  patientAlerts: undefined,
  setPatientAlerts: () => {},
  moreDetails: undefined,
  setMoreDetails: () => {},
  moreDetailsLoading: false,
  setMoreDetailsLoading: () => {},
});

export const ROPatientContextProvider = ({ children }: { children: React.ReactNode }): JSX.Element => {
  const [patientDetails, setPatientDetails] = useState<any>();
  const [patientAlerts, setPatientAlerts] = useState<any>();
  const [moreDetails, setMoreDetails] = useState<any>();
  const [moreDetailsLoading, setMoreDetailsLoading] = useState<boolean>(false);

  return (
    <ROPatientContext.Provider
      value={{
        patientDetails,
        setPatientDetails,
        patientAlerts,
        setPatientAlerts,
        moreDetails,
        setMoreDetails,
        moreDetailsLoading,
        setMoreDetailsLoading,
      }}>
      {children}
    </ROPatientContext.Provider>
  );
};
